/**
 * HashRouter only reads routes after `#`. API activation redirects use pathname URLs because
 * HttpServletResponse.sendRedirect ignores URL fragments.
 */
export function redirectLegacyHashRouterPaths(): void {
  const { pathname, search, origin } = window.location;
  const hashPath = window.location.hash.replace(/^#/, '');

  if (pathname.endsWith('/user-registrations') && search.includes('code=')) {
    if (hashPath.startsWith('/user-registrations')) {
      return;
    }
    window.location.replace(`${origin}/#/user-registrations${search}`);
    return;
  }

  if (pathname.endsWith('/login') && search.includes('activation=')) {
    if (hashPath.startsWith('/login')) {
      return;
    }
    window.location.replace(`${origin}/#/login${search}`);
  }
}
